import React from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import ButtonTable from "../../common/table/buttonTable";

export function ModalSelecaoPdfFatura(props) {
    if (!props.visible) return null;

    return (
        <ModalAlert titulo="Selecione o documento a ser visualizado" handleClose={props.handleClose}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <tbody>
                    <tr style={{ borderBlock: "1px solid #ccc", paddingTop: 30 }}>
                        <td colSpan={2} style={{ paddingInline: 50 }}>
                            Fatura Principal
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "43%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"primary"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf}
                                    visible={true}
                                    event={() => {
                                        props.buscarPdf(
                                            props.state.itemPdfSelecionado.id,
                                            `UC-${props.state.itemPdfSelecionado.nome_unidade_consumidora.replace(/\./g, "").split("-")[0].trim()}_${String(
                                                props.state.itemPdfSelecionado.competencia
                                            ).substring(4, 6)}-${String(props.state.itemPdfSelecionado.competencia).substring(0, 4)}`
                                        );
                                        props.setArquivoPDF();
                                    }}
                                />
                                <div>Fatura</div>
                            </div>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #ccc" }}>
                        <td style={{ paddingInline: 50 }}>Fatura Adicional - Custo Energia ACL Longo Prazo (Mercado Livre)</td>
                        <td style={{ textAlign: "center", verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_lp ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_lp ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "47%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"warning"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_lp}
                                    visible={true}
                                    event={() => {
                                        const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                        props.buscarPdfFaturaAdicional({
                                            id_fatura: props.state.itemPdfSelecionado.id,
                                            nomePdf: `Custo_Energia_ACL_LP_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(
                                                4,
                                                6
                                            )}-${String(competencia).substring(0, 4)}`,
                                            id_produto: 19958,
                                        });
                                    }}
                                />
                                <div>NF-e</div>
                            </div>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf_boleto_energia_acl_lp ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf_boleto_energia_acl_lp ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "43%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"warning"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf_boleto_energia_acl_lp}
                                    visible={true}
                                    event={() => {
                                        const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                        props.buscarPdfFaturaAdicional({
                                            id_fatura: props.state.itemPdfSelecionado.id,
                                            nomePdf: `Boleto_Energia_ACL_LP_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(
                                                4,
                                                6
                                            )}-${String(competencia).substring(0, 4)}`,
                                            id_produto: 20277,
                                        });
                                    }}
                                />
                                <div>Boleto</div>
                            </div>
                        </td>
                    </tr>
                    {props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_cp && (
                        <tr style={{ borderBottom: "1px solid #ccc" }}>
                            <td style={{ paddingInline: 50 }}>Fatura Adicional - Custo Energia ACL Curto Prazo (Mercado Livre)</td>
                            <td style={{ textAlign: "center", verticalAlign: "top" }}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "start",
                                        alignItems: "center",
                                    }}
                                >
                                    <i
                                        className={props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_cp ? "fas fa-check" : "fas fa-times"}
                                        style={{
                                            color: props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_cp ? "#2cdf2c" : "red",
                                            position: "absolute",
                                            top: 27,
                                            left: "47%",
                                            fontSize: "0.8rem",
                                        }}
                                    ></i>
                                    <ButtonTable
                                        style={{ margin: 0 }}
                                        title="Visualizar PDF"
                                        type={"warning"}
                                        icon={"fas fa-file-pdf"}
                                        disabled={!props.state.itemPdfSelecionado.arquivo_pdf_custo_energia_acl_cp}
                                        visible={true}
                                        event={() => {
                                            const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                            props.buscarPdfFaturaAdicional({
                                                id_fatura: props.state.itemPdfSelecionado.id,
                                                nomePdf: `Custo_Energia_ACL_CP_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(
                                                    4,
                                                    6
                                                )}-${String(competencia).substring(0, 4)}`,
                                                id_produto: 19959,
                                            });
                                        }}
                                    />
                                    <div>NF-e</div>
                                </div>
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "start",
                                        alignItems: "center",
                                    }}
                                >
                                    <i
                                        className={props.state.itemPdfSelecionado.arquivo_pdf_boleto_energia_acl_cp ? "fas fa-check" : "fas fa-times"}
                                        style={{
                                            color: props.state.itemPdfSelecionado.arquivo_pdf_boleto_energia_acl_cp ? "#2cdf2c" : "red",
                                            position: "absolute",
                                            top: 27,
                                            left: "43%",
                                            fontSize: "0.8rem",
                                        }}
                                    ></i>
                                    <ButtonTable
                                        style={{ margin: 0 }}
                                        title="Visualizar PDF"
                                        type={"warning"}
                                        icon={"fas fa-file-pdf"}
                                        disabled={!props.state.itemPdfSelecionado.arquivo_pdf_boleto_energia_acl_cp}
                                        visible={true}
                                        event={() => {
                                            props.buscarPdfFaturaAdicional({
                                                id_fatura: props.state.itemPdfSelecionado.id,
                                                id_produto: 20278,
                                            });
                                        }}
                                    />
                                    <div>Boleto</div>
                                </div>
                            </td>
                        </tr>
                    )}
                    <tr style={{ borderBottom: "1px solid #ccc" }}>
                        <td style={{ paddingInline: 50 }}>Fatura Adicional - Custo Gestão ACL (Mercado Livre)</td>
                        <td style={{ textAlign: "center", verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf_custo_gestao_acl ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf_custo_gestao_acl ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "47%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"dark"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf_custo_gestao_acl}
                                    visible={true}
                                    event={() => {
                                        const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                        props.buscarPdfFaturaAdicional({
                                            id_fatura: props.state.itemPdfSelecionado.id,
                                            nomePdf: `Custo_Gestão_ACL_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(4, 6)}-${String(
                                                competencia
                                            ).substring(0, 4)}`,
                                            id_produto: 19002,
                                        });
                                    }}
                                />
                                <div>NF-e</div>
                            </div>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf_boleto_gestao_acl ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf_boleto_gestao_acl ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "43%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"dark"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf_boleto_gestao_acl}
                                    visible={true}
                                    event={() => {
                                         const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                        props.buscarPdfFaturaAdicional({
                                            id_fatura: props.state.itemPdfSelecionado.id,
                                            nomePdf: `Boleto_Gestão_ACL_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(
                                                4,
                                                6
                                            )}-${String(competencia).substring(0, 4)}`,
                                            id_produto: 20279,
                                        });
                                    }}
                                />
                                <div>Boleto</div>
                            </div>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #ccc" }}>
                        <td style={{ paddingInline: 50 }}>Fatura Adicional - Tx. Contribuição Associativa CCEE (Mercado Livre)</td>
                        <td style={{ textAlign: "center", verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf_contribuicao_associativa_ccee ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf_contribuicao_associativa_ccee ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "47%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"info"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf_contribuicao_associativa_ccee}
                                    visible={true}
                                    event={() => {
                                        const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                        props.buscarPdfFaturaAdicional({
                                            id_fatura: props.state.itemPdfSelecionado.id,
                                            nomePdf: `Custo_Contribuição_Associativa_CCEE_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(
                                                4,
                                                6
                                            )}-${String(competencia).substring(0, 4)}`,
                                            id_produto: 19003,
                                        });
                                    }}
                                />
                                <div>NF-e</div>
                            </div>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                <i
                                    className={props.state.itemPdfSelecionado.arquivo_pdf_boleto_contribuicao_associativa_ccee ? "fas fa-check" : "fas fa-times"}
                                    style={{
                                        color: props.state.itemPdfSelecionado.arquivo_pdf_boleto_contribuicao_associativa_ccee ? "#2cdf2c" : "red",
                                        position: "absolute",
                                        top: 27,
                                        left: "43%",
                                        fontSize: "0.8rem",
                                    }}
                                ></i>
                                <ButtonTable
                                    style={{ margin: 0 }}
                                    title="Visualizar PDF"
                                    type={"info"}
                                    icon={"fas fa-file-pdf"}
                                    disabled={!props.state.itemPdfSelecionado.arquivo_pdf_boleto_contribuicao_associativa_ccee}
                                    visible={true}
                                    event={() => {
                                       const { competencia, nome_unidade_consumidora } = props.state.itemPdfSelecionado;
                                        props.buscarPdfFaturaAdicional({
                                            id_fatura: props.state.itemPdfSelecionado.id,
                                            nomePdf: `Boleto_Contribuição_Associativa_CCEE_UC_${nome_unidade_consumidora.replace(/\./g, "").split(" - ")[0]}_${String(competencia).substring(
                                                4,
                                                6
                                            )}-${String(competencia).substring(0, 4)}`,
                                            id_produto: 20280,
                                        });
                                    }}
                                />
                                <div>Boleto</div>
                            </div>
                        </td>
                    </tr>
                    {props.usuarioLogado.acesso_cliente || !(props.state.itemPdfSelecionado.erros_mercado_livre || []).length ? null : (
                        <tr style={{ borderBottom: "1px solid #ccc", color: "red" }}>
                            <td colSpan={3} style={{ paddingInline: 50 }}>
                                <b>Erros de Importação</b>
                                <ul style={{ padding: 0 }}>
                                    {(props.state.itemPdfSelecionado.erros_mercado_livre || []).map((item) => (
                                        <li>{item}</li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </ModalAlert>
    );
}
